/**
 * Adults first, children second, then everything else in the order it came.
 *
 * The till holds its catalogue `ORDER BY kind, name`, so a gate's board read
 * ADULT, CAMERA, CHILDREN — "CA" sorts before "CH" — and the two plates sold
 * most were not side by side (Dee, 31 Oct 2026).
 *
 * Matched on how the name **starts**, ignoring case, so "Adult foreigner" and
 * the park's own "CHILDEREN" both land where a cashier reaches for them. Within
 * each group, and for everything else, the order given is kept: the sort is
 * stable.
 */
// ponytail: matched by name because the API has no display order on a catalogue
// item. When the back office can set one, sort by that and delete this file.
const RANKED = ['adult', 'child'];

const rank = (name: string): number => {
  const lower = name.trim().toLowerCase();
  const found = RANKED.findIndex((start) => lower.startsWith(start));

  return found === -1 ? RANKED.length : found;
};

export const adultsThenChildren = <T extends { readonly name: string }>(items: readonly T[]): T[] =>
  [...items].sort((a, b) => rank(a.name) - rank(b.name));
